import { Picker } from 'emoji-mart'
import React from 'react'
import 'emoji-mart/css/emoji-mart.css'
import './EmojiPicker.scss'

type EmojiPickerProps = {
  autoFocus?: boolean
  color?: string
  emoji?: string
  emojiSize?: number
  onClick?(...args: unknown[]): unknown
  onSelect?(...args: unknown[]): unknown
  onSkinChange?(...args: unknown[]): unknown
  onOuterClick?(...args: unknown[]): unknown
  native?: boolean
  recent?: unknown[]
  set?: string
  showPreview?: boolean
  showSkinTones?: boolean
  title?: string
  rootStyle?: object
  perLine?: number
}

class EmojiPicker extends React.PureComponent<EmojiPickerProps> {
  root: any
  constructor(props: any) {
    super(props)
    this.root = React.createRef()
  }

  componentDidMount() {
    if (this.props.onOuterClick) {
      document.addEventListener('click', this.onOuterClick, { passive: true })
    }
  }

  componentWillUnmount() {
    if (this.props.onOuterClick) {
      document.removeEventListener('click', this.onOuterClick)
    }
  }

  onOuterClick = (e: any) => {
    if (this.root.current && !this.root.current.contains(e.target)) {
      this.props.onOuterClick?.()
    }
  }

  render() {
    const { rootStyle, onOuterClick, ...rest } = this.props
    return (
      <div className="EmojiPicker-root" ref={this.root} style={rootStyle}>
        <div className="EmojiPicker-main">
          <Picker {...(rest as any)} />
        </div>
      </div>
    )
  }
}

// @ts-expect-error TS(2339): Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
EmojiPicker.defaultProps = {
  title: 'Pick your emoji...',
  color: '#6e6cb2',
  emoji: 'point_up',
  native: true,
  showPreview: false,
  perLine: 8,
}

export default EmojiPicker
